module.exports = __webpack_public_path__ + "img/138.7f171e1d.jpg";